import { useQuery } from "react-query";
import axios from "axios";

import {getApiSitePrefix} from "../../functions/SiteDefaults";

const apiSitePrefix = getApiSitePrefix();

const getData = async () => {
    const { data } = await axios.get(
        `${apiSitePrefix}/accesstoken/`
    );
    return data;
};

export default function useAccessToken() {
    return useQuery(["accesstoken"], () => getData());
}